export const RESOURCE = {
  DD_ICON_EDIT: 'resource-icon-edit',
  DD_ICON_DUPLICATE: 'resource-icon-duplicate',
  DD_ICON_ARCHIVE: 'resource-icon-archive',
  DD_ICON_UNARCHIVE: 'resource-icon-unarchive',
  PRIMARY_BTN: 'archive-confirm-btn',
  SAVE_CHANGES_BUTTON: 'resource-save-changes-button',
  LABOR_SEARCH_INPUT: 'labor-search-input',
  EQUIPMENT_SEARCH_INPUT: 'equipment-search-input',
  PRIMARY_BTN_DEFAULT: 'create-resource-btn',
  DEFAULT_CLOSE_ICON: 'resource-dialog-close-icon',
  SECONDARY_BTN: 'dialog-leave-btn',

  MENU_ITEM_CONDITIONAL_TOOLTIP: 'resource-more-menu-list',
  INFO_ICON_WRAP: 'info-icon-wrap',
  ARCHIVED_LABOR_LIST_BTN: 'archived-labor-list-btn',
  ARCHIVED_EQUIPMENT_LIST_BTN: 'archived-equipment-list-btn',
  ARCHIVED_NAME_CELL: 'archived-name-cell',
  WITH_MORE_ICON: 'archived-resource-more-icon',
  RESOURCE_NAME_CELL_TEXT: 'resource-name-cell-text',
  DIALOG_TITLE: 'resourceDialogTitle',
  LABOR_BUTTON: 'laborTabButton',
  EQUIPMENT_BUTTON: 'equipmentTabButton',
  RESOURCE_CELL_ADD: 'resourceCellAddBtn',
  RESOURCE_CELL_POPUP: 'resourceCellPopup',
  RESOURCE_CELL_POPUP_EQUIPMENT_INPUT: 'resourceCellPopupEquipmentInput',
  RESOURCE_COUNT_INPUT: 'resourceCountInput',
  RESOURCE_ACTION: 'resourceAddActionBtn',
  NAME_COLUMN_HEADER: 'resourceNameColumnHeader',
  CODE_COLUMN_HEADER: 'resourceCodeColumnHeader',
  DESCRIPTION_COLUMN_HEADER: 'resourceDescriptionColumnHeader',
  DIALOG_WRAPPER: 'resourceDialogBox',
  DIALOG_CONTENT_FORM_WRAPPER: 'resourceDialogContentForm',
  FORM_WRAPPER_INPUT_WRAPPER_LABEL: 'resourceFormInputLabel',
  LABOR_NAME_INPUT: 'laborNameInput',
  EQUIPMENT_NAME_INPUT: 'equipmentNameInput',
  LABOR_CODE_INPUT_FIELD: 'laborCodeInputField',
  EQUIPMENT_CODE_INPUT_FIELD: 'equipmentCodeInputField',
  DESCRIPTION_TEXTAREA: 'resourceDescriptionTextarea',
  WITH_MORE_ICON_MORE_ICON: 'resourceMoreMenuIcon',
  RESOURCE_DRILLDOWN_BUTTON: 'resourceDrilldownButton'
} as const;
